import { borderColors } from "../../cssUtils/constants";
import { ReactComponent as MessageIcon } from "../../assets/images/icons/header/Union.svg";
import { Box, Typography } from "@mui/material";

const WhatsappButton = ({isRcs}) => {

  return (
    <Box
      sx={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        border: 1,
        borderRadius: 2,
        px: 1.5,
        py: 0.5,
        borderColor: borderColors.cardBorderPrimaryGrayColor,
      }}
    >
      {/* Icon - only show for WhatsApp */}
      {!isRcs && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "16px",
          }}
        >
          <MessageIcon
            style={{
              height: "16px",
              width: "16px",
              display: "block",
            }}
          />
        </Box>
      )}

      {/* Text */}
      <Typography
        sx={{ color: "#61748C", fontSize: "14px", fontWeight: "500" }}
      >
        {isRcs ? "RCS" : "WhatsApp"}
      </Typography>
    </Box>
  );
};

export default WhatsappButton;
